/* eslint-disable import/no-cycle */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MODAL_NAMES from 'constants/modalNames'
import { fetchCabins } from 'actions/catalog/cabins'
import { fetchFlightsOffers } from 'actions/flightsOffers'
import { clearFlightSummary } from 'actions/flightSummary'
import { changeModalState , resetAllModals } from 'actions/modalActions'
import { fetchSearchBoxRules } from 'actions/rules/searchBox'
import { fetchSuggestions, swipeSuggestions, clearAllSuggestions } from 'actions/suggestions'
import { Switcher } from 'components/checkbox'
import { DashedSeparator } from 'components/common'
import { IconNames } from 'components/icons'
import Input from 'components/input'
import { TransitionLoader } from 'components/loaders'
import WaitingForResultLoader from 'components/loaders/WaitingForResultLoader'
import { RadioGroup } from 'components/radio-button'
import { ReSearchBoxErrorMessage } from 'components/re-search-box/collapsible'
import SwapFieldsButton from 'components/swap-fields-button'
import theme from 'components/theme'
import CONFIG from 'config'
import { SEARCH_BOX } from 'constants/searchBox'
import { TRIP_TYPES } from 'constants/tripTypes'
import e2eClasses from 'helpers/automation'
import { formatData, getFlightsSearchDataUrl, getUrlParams } from 'helpers/url'
import { getOrdinal, isEmpty, isMobile, isMobileOrTablet, isTablet } from 'helpers/utils'
import { validateField, promoCode, alphanumeric } from 'helpers/validations'
import { LANGUAGE_TAGS } from 'localization/constants/languages'
import NAMESPACES from 'localization/constants/namespaces'
import { getCabins } from 'selectors/cabins'
import { isFetchingCampaigns, getCampaignFetchError } from 'selectors/campaigns'
import { getConferenceCodeError } from 'selectors/cms/eventCategories'
import { getFlightsOffersIsFetching } from 'selectors/flightsOffers'
import { mapMediaType } from 'selectors/mediaType'
import {
  getAvailableCabins,
  getDefaultFlightType,
  getPromoCodeEnabled
} from 'selectors/searchBoxRules'
import { getSuggestionsFrom, getSuggestionsTo } from 'selectors/suggestions'

import AirportInput from './airport-input'
import ConfigPassengerInput from './config-passenger-input'
import DatePickerWrapper from './date-picker-wrapper'
import EditLegLink from './edit-leg-link'
import {
  getFlightTypesRadioGroupOptions,
  saveRecentSearchs,
  getCampaignConstraints,
  updateFromCampaign,
  createEmptyLeg,
  getPathName
} from './helpers'
import ModalRedirectionPaymentGateway from './modal-redirection-payment-gateway'
import MultidestinyHeader from './multidestiny-header'
import PromotionCode from './promotion-code'
import SearchButton from './search-button'
import {
  CampaignConditionalFields,
  CampaignConditionalFieldsItem,
  CampaignInputLabel,
  ColumnsContainer,
  Container,
  FieldsContainer,
  FragmentContainer,
  InputWrapper,
  Leg,
  RadioGroupContainer,
  Separator,
  SeparatorWrapper,
  StyledBtnContainer,
  StyledContainer,
  SwapFieldsWrapper,
  SwitcherContainer,
  SwitchersContainer
} from './styled'

class SearchBox extends Component {
  constructor(props) {
    super(props)
    const {
      legs,
      flightType,
      passengers,
      flexDates,
      promoCodeEnabledByRule,
      awardBooking
    } = this.props

    this.state = {
      legs: legs || [createEmptyLeg()],
      flightTypes: flightType || TRIP_TYPES.ROUND_TRIP,
      today: new Date(),
      //undefined, null, and true should set initial flexDates as true to meet business req.
      flexDates: flexDates !== false,
      awardBooking: CONFIG.ENABLE_MILES && awardBooking,
      passengers: passengers || { passengers: [1, 0, 0], radioGroupValue: 'Economy' },
      promoCode: '',
      promoCodeChecked: '',
      promoCodeEnabled: promoCodeEnabledByRule
    }

    this.container = React.createRef()
  }

  /** @async needs to await for searchbox rules to retrieve defaultFlightType which must only be set
   * at mounting point. If defaultFlightType is empty it should take default value set in constructor */
  async componentDidMount() {
    this.scrollToComponent = require('react-scroll-to-component')

    isEmpty(this.props.cabins) && this.props.fetchCabins()

    await this.props.fetchSearchBoxRules(this.getDefaultRutes())

    if (this.props.defaultFlightType && !this.props.campaignProps) {
      this.setState({
        flightTypes: this.props.defaultFlightType
      })
    }

    if (this.props.campaignProps) {
      if (this.props.campaignProps.searchTypeDefault) {
        this.setState({
          flightTypes: this.props.campaignProps.searchTypeDefault
        })
      } else {
        const campaingFlightTypes = this.props.campaignProps.flightTypes

        if (campaingFlightTypes && campaingFlightTypes[0]) {
          const flightType = campaingFlightTypes.includes(TRIP_TYPES.ROUND_TRIP)
            ? TRIP_TYPES.ROUND_TRIP
            : campaingFlightTypes.includes(TRIP_TYPES.ONE_WAY)
            ? TRIP_TYPES.ONE_WAY
            : campaingFlightTypes[0]

          this.setState({
            flightTypes: flightType
          })
        }
      }
    }
    if (this.props.location.state?.awardBooking) {
      this.setState({ awardBooking: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.availableCabins !== this.props.availableCabins) {
      const { radioGroupValue } = this.state.passengers

      if (!this.props.availableCabins.includes(radioGroupValue)) {
        this.setState({
          passengers: {
            ...this.state.passengers,
            radioGroupValue: this.props.availableCabins[0]
          }
        })
      }
    }

    if (prevProps.promoCodeEnabledByRule !== this.props.promoCodeEnabledByRule) {
      this.setState({
        promoCodeEnabled: this.props.promoCodeEnabledByRule,
        promoCode: '',
        promoCodeError: '',
        promoCodeChecked: false
      })
    }

    if (
      prevProps.campaignProps !== this.props.campaignProps &&
      !isEmpty(this.props.campaignProps)
    ) {
      const {
        campaignProps,
        campaignProps: { isConference },
        campaignFieldsInitialValues
      } = this.props

      const { legs, passengers } = this.state

      const nextState = updateFromCampaign(
        campaignProps,
        passengers,
        campaignFieldsInitialValues,
        legs
      )

      this.setState(
        prevState => ({
          ...prevState,
          ...nextState,
          passengers: {
            ...prevState.passengers,
            ...nextState.passengers
          }
        }), // suggestions from previous search should be cleared
        () => {
          if (
            isConference &&
            (!isEmpty(this.props.suggestionsFrom) || !isEmpty(this.props.suggestionsTo))
          ) {
            this.props.clearAllSuggestions()
          }
        }
      )
    }

    if (!prevProps.isResearchBoxExpanded && this.props.isResearchBoxExpanded) {
      this.setState({
        flightTypes: this.props.flightType,
        legs: this.props.legs,
        passengers: this.props.passengers,
        flexDates: this.props.flexDates,
        promoCode: this.props.promoCode,
        promoCodeEnabled: this.props.promoCodeEnabledByRule
      })
    }

    /* If an event is selected with a campaign that is invalid, searchbox should load default rules */
    if (isEmpty(prevProps.campaignError) && !isEmpty(this.props.campaignError)) {
      this.props.fetchSearchBoxRules(this.getDefaultRutes())
    }
  }

  getDefaultRutes = () => {
    const { leg } = this.props.location.search
      ? getUrlParams(this.props.location.search.split('?').pop())
      : ''
    const mappedRoutes = (leg || '').split('-', 2).join('-')
    return mappedRoutes ? [mappedRoutes] : []
  }

  conferenceCodeHandler = ({ target: { value } }) => {
    this.setState(prevState => ({ ...prevState, conferenceCode: { value } }))
  }

  handleFlightTypeChange = value => {
    if (this.props.campaignProps && this.props.campaignProps.isConference) {
      this.props.onChangeFlightType(value === TRIP_TYPES.MULTIDESTINY)
    }

    const legs = [this.state.legs[0]]
    const [firstLeg] = legs

    delete firstLeg.dateFromError
    delete firstLeg.fromError
    delete firstLeg.toError
    firstLeg.dateToError && delete firstLeg.dateToError

    if (value === TRIP_TYPES.MULTIDESTINY) {
      legs.push(createEmptyLeg())
    }

    this.setState({
      legs,
      flightTypes: value,
      flexDates: value !== TRIP_TYPES.MULTIDESTINY
    })
    if (this.props.isResearch && this.props.noResults) {
      this.setState({ clearErrorMessage: true })
      this.props.onChangeFlightType && this.props.onChangeFlightType()
    }
  }

  callbackToValidate = (inputPosition, legNumber) => this.areFieldsValid(inputPosition, legNumber)

  onFlightRouteChange = () => {
    const filledRoutes = this.state.legs.filter(
      ({ fromSelected, toSelected }) => !isEmpty(fromSelected) && !isEmpty(toSelected)
    )

    const mappedRoutes = filledRoutes.map(
      ({ fromSelected, toSelected }) =>
        `${fromSelected.id.toUpperCase()}-${toSelected.id.toUpperCase()}`
    )

    // if there is valid campaign data, searchbox rules are not used
    if (
      !this.props.isCampaignRestricted ||
      (this.props.isCampaignRestricted && this.props.campaignError)
    ) {
      if (!isEmpty(mappedRoutes)) {
        this.props.fetchSearchBoxRules(mappedRoutes)
      }
    }
  }

  validateLength = value => value.length >= SEARCH_BOX.AUTOSUGGEST_MIN_LENGTH

  handleDateFromInputChange = (value, index) => {
    this.setState(
      prevState => {
        const legsArray = [...prevState.legs]
        legsArray[index].date =
          this.state.flightTypes === TRIP_TYPES.ROUND_TRIP ? value : { from: value, to: undefined }
        /* check date consistency for next legs */
        for (let next = index + 1; next < legsArray.length; next++) {
          if (legsArray[next].date && legsArray[next].date.from < value) {
            legsArray[next].date = { from: value }
          }
        }
        return { items: legsArray }
      },
      () => {
        this.callbackToValidate(SEARCH_BOX.DATE_FROM_POSITION, index)
        this.callbackToValidate(SEARCH_BOX.DATE_TO_POSITION, index)
        if (isMobile(this.props.mediaType)) {
          if (this.state.flightTypes === TRIP_TYPES.ROUND_TRIP) {
            const legs = [this.state.legs[0]]
            this.setState(
              {
                legs,
                flightTypes: TRIP_TYPES.ONE_WAY
              },
              () =>
                this.setState({
                  legs,
                  flightTypes: TRIP_TYPES.ROUND_TRIP
                })
            )
          }
        }
      }
    )
  }

  swapOriginDestination = index => {
    const legs = [...this.state.legs]
    const { fromSelected, toSelected } = legs[index]

    if (fromSelected && toSelected) {
      legs[index].fromSelected = toSelected
      legs[index].toSelected = fromSelected

      this.setState({ legs }, () => {
        this.callbackToValidate(SEARCH_BOX.TO_POSITION, index)
        this.props.swipeSuggestions(index)
      })
    }
  }

  handlePassengersDataChange = passengers => {
    this.setState({ passengers }, () =>
      this.callbackToValidate(SEARCH_BOX.CONFIG_PASSENGER_POSITION)
    )
  }

  handleFlexDatesChange = () => {
    this.setState({ flexDates: !this.state.flexDates })
  }

  handleAwardBookingChange = () => {
    this.setState({ awardBooking: !this.state.awardBooking })
    this.setState({ promoCode: '' })
    this.setState({ promoCodeChecked: false })
  }

  handlePromoCodeCheckChange = checked => {
    if (!checked) {
      this.setState({ errorPromoCode: '', promoCode: '', promoCodeChecked: false })
    } else {
      this.setState({ promoCodeChecked: true })
    }
  }

  handleCampaignFieldsChange = fieldCode => ({ target: { value } }) =>
    this.setState(
      prevState => ({
        ...prevState,
        conditionalFields: {
          ...prevState.conditionalFields,
          [fieldCode]: { ...prevState.conditionalFields[fieldCode], value }
        }
      }),
      () => this.callbackToValidate(SEARCH_BOX.CAMPAIGN_FIELDS_POSITION)
    )

  handlePromoCodeChange = promoCode => {
    this.setState({ promoCode })
  }

  validatePromoCode = validation => {
    const error = !validation
      ? this.props.t('shopping.search-box.validation.promo-code.required')
      : false

    return !error
  }

  isPromoCodeValid = () => {
    if (!validateField(alphanumeric, this.state.promoCode)) {
      this.setState({
        errorPromoCode: this.props.t('shopping.search-box.validation.promo-code-pattern')
      })
      return false
    } else if (!validateField(promoCode, this.state.promoCode)) {
      this.setState({
        errorPromoCode: this.props.t('shopping.search-box.validation.promo-code.required')
      })
      return false
    } else {
      this.setState({ errorPromoCode: '' })
      return true
    }
  }

  validateRedirectUrl = url => {
    if (
      CONFIG.ENABLE_CHILE_REDIRECTION_PAYMENT_GATEWAY &&
      this.props.i18n.language === LANGUAGE_TAGS.CHILE
    ) {
      this.props.changeModalState({
        isVisible: true,
        modalName: MODAL_NAMES.REDIRECTION_PAYMENT_GATEWAY
      })

      this.setState({
        redirectionPaymentGateway: url.replace(
          LANGUAGE_TAGS.CHILE.toLowerCase(),
          LANGUAGE_TAGS.URUGUAY.toLowerCase()
        )
      })
    } else this.props.history.push(url)
  }

  handleOnSubmit = async () => {
    if (!this.areFieldsValid()) {
      return
    }
    const { isCampaignRestricted, campaignError } = this.props
    const stateData = { ...this.state }

    if (isCampaignRestricted && isEmpty(campaignError)) {
      const {
        campaignProps: { campaignCode, isConference, conferenceName }
      } = this.props
      const { conferenceCode, conditionalFields } = this.state

      stateData.campaignData = {
        campaignCode
      }
      delete stateData.conferenceCode
      delete stateData.conditionalFields

      if (isConference) {
        stateData.campaignData.conferenceCode = conferenceCode.value
        stateData.campaignData.conferenceName = conferenceName
      } else {
        stateData.campaignData.promotionFieldEntries =
          conditionalFields && Object.entries(conditionalFields)
      }
    }

    const { shoppingId } = getUrlParams(this.props.location.search.split('?').pop())
    const search = getFlightsSearchDataUrl(formatData(stateData, shoppingId))
    const pathname = getPathName(this.state.flexDates, this.props.i18n.language)

    this.state.legs.forEach(leg => {
      saveRecentSearchs(SEARCH_BOX.STORAGE_KEY, leg.fromSelected)
      saveRecentSearchs(SEARCH_BOX.STORAGE_KEY, leg.toSelected)
    })

    if (this.props.campaignProps && this.props.campaignProps.isConference) {
      //This ugly thing is to workaround validation of conference code
      await this.props.fetchFlightsOffers(search)

      if (this.props.conferenceCodeError) {
        return this.setState(prevState => ({
          ...prevState,
          conferenceCode: {
            ...prevState.conferenceCode,
            error: this.props.t(this.props.conferenceCodeError)
          }
        }))
      }
    }

    this.props.resetAllModals()
    this.props.clearFlightSummary()

    this.validateRedirectUrl(`${pathname}${search}`)
  }

  isMomentToValidate = (inputPosition, selectedPosition) =>
    !selectedPosition || inputPosition <= selectedPosition

  validateLeg = (leg, legNumber, selectedPosition) => {
    return [
      this.isMomentToValidate(SEARCH_BOX.FROM_POSITION, selectedPosition, legNumber)
        ? this.validateField(
            'fromError',
            this.isFromValid(leg),
            this.props.t('label.from.error-message'),
            legNumber
          )
        : false,

      this.isMomentToValidate(SEARCH_BOX.TO_POSITION, selectedPosition, legNumber)
        ? this.validateField(
            'toError',
            this.isToValid(leg),
            this.props.t('label.to.error-message'),
            legNumber
          )
        : false,

      this.isMomentToValidate(SEARCH_BOX.DATE_FROM_POSITION, selectedPosition, legNumber)
        ? this.validateField(
            'dateFromError',
            this.isDateFromValid(leg),
            this.props.t('label.date-from.error-message'),
            legNumber
          )
        : false,

      this.isMomentToValidate(SEARCH_BOX.DATE_TO_POSITION, selectedPosition, legNumber)
        ? this.state.flightTypes === TRIP_TYPES.ROUND_TRIP
          ? this.validateField(
              'dateToError',
              this.isDateToValid(leg),
              this.props.t('label.date-to.error-message'),
              legNumber
            )
          : true
        : false
    ]
  }

  areFieldsValid = (selectedPosition, legNumber) => {
    const validations = []

    if (legNumber === undefined) {
      /* validate all legs */
      legNumber = this.state.legs.length
    }
    const legsToValidate = this.state.legs.slice(0, legNumber + 1)

    legsToValidate.forEach((leg, legNumber) => {
      validations.push(...this.validateLeg(leg, legNumber, selectedPosition))
    })

    validations.push(
      this.isMomentToValidate(SEARCH_BOX.CONFIG_PASSENGER_POSITION, selectedPosition)
        ? this.validateField(
            'passengersError',
            this.isPassengersValid(),
            this.props.t('shopping.search-box.passengers.required')
          )
        : false
    )

    if (this.state.promoCodeChecked) {
      validations.push(this.validatePromoCode(this.isPromoCodeValid()))
    }

    if (
      this.props.isCampaignRestricted &&
      this.props.campaignProps.isConference &&
      this.isMomentToValidate(SEARCH_BOX.CONFERENCE_CODE_POSITION, selectedPosition)
    ) {
      validations.push(this.validateConferenceCodeField(this.state.conferenceCode.value))
    }

    if (
      !isEmpty(this.props.campaignProps && this.props.campaignProps.validationFields) &&
      this.isMomentToValidate(SEARCH_BOX.CAMPAIGN_FIELDS_POSITION, selectedPosition)
    ) {
      this.props.campaignProps.validationFields.forEach(validationField =>
        validations.push(
          this.validateCampaignField(
            validationField.code,
            this.isCampaignFieldValid(
              validationField.pattern,
              this.state.conditionalFields[validationField.code].value
            ),
            this.props.t('shopping.search-box.campaign-field.error')
          )
        )
      )
    }
    return validations.every(arrayItem => arrayItem)
  }

  validateCampaignField = (field, validation, errorMessage) => {
    const error = !validation ? errorMessage : false
    this.setState(prevState => {
      const fields = { ...prevState.conditionalFields }
      fields[field].error = error
      return { conditionalFields: fields }
    })

    return !error
  }

  validateConferenceCodeField = value => {
    const [isValid, errorMessage] = this.isValidConferenceCode(value)
    !isValid &&
      this.setState(prevState => ({
        conferenceCode: { ...prevState.conferenceCode, error: errorMessage }
      }))
    return isValid
  }

  isValidConferenceCode = value =>
    !value
      ? [false, this.props.t(`${NAMESPACES.EVENTS}:events.search-box.conference-code.required`)]
      : [
          new RegExp().test(value),
          this.props.t(`${NAMESPACES.EVENTS}:events.search-box.conference-code.pattern`)
        ]

  validateField = (field, validation, errorMessage, legNumber) => {
    const error = !validation ? errorMessage : false
    if (legNumber === undefined) {
      this.setState({ [field]: error })
    } else {
      this.setState(prevState => {
        const legsArray = [...prevState.legs]
        legsArray[legNumber][field] = error
        return { items: legsArray }
      })
    }
    return !error
  }

  isFromValid = leg => leg.fromSelected

  isToValid = leg => leg.toSelected

  isDateFromValid = leg => leg.date && leg.date.from

  isDateToValid = leg => {
    return (
      leg.date && leg.date.to && (!leg.date.from || (leg.date.from && leg.date.to >= leg.date.from))
    )
  }

  isPassengersValid = () => {
    const isValid =
      this.state.passengers !== undefined &&
      Object.values(this.state.passengers.passengers).some(quantity => quantity > 0)

    return isValid
  }

  isCampaignFieldValid = (pattern, field) => {
    let isValid
    try {
      isValid = !pattern.indexOf('/') ? pattern.test(field) : new RegExp(pattern).test(field)
    } catch (e) {
      isValid = true
    }
    return isValid
  }

  addLeg = () => {
    const legs = [...this.state.legs, createEmptyLeg()]

    this.setState({ legs })
  }

  removeLeg = position => {
    const legs = this.state.legs.filter((_, index) => index !== position)

    this.setState({
      legs
    })
  }

  collapseLeg = index => {
    this.setState(prevState => {
      const legsArray = [...prevState.legs]
      legsArray[index].isExpanded = !legsArray[index].isExpanded
      return { items: legsArray }
    })
  }

  shouldShowLegContent(index) {
    if (this.state.flightTypes === TRIP_TYPES.MULTIDESTINY) {
      return this.state.legs[index].isExpanded
    }

    return true
  }

  getSearchButton = () => (
    <SearchButton
      disableBtn={this.props.disableBtn}
      shouldShowTermsLink={this.props.shouldShowTermsLink}
      labelDefault={this.props.t('shopping.search-box.search-flights')}
      labelEvents={this.props.t('shopping.search-box.terms-and-conditions-events.label')}
      isResearch={this.props.isResearch}
      isConference={!isEmpty(this.props.campaignProps) && this.props.campaignProps.isConference}
      isResearchBoxExpanded={this.props.isResearchBoxExpanded}
      handleOnSubmit={this.handleOnSubmit}
      openTermsModalHandler={this.props.openTermsModalHandler}
    />
  )

  handleInputChange = (suggestionEvent, index, field, group) => {
    if (suggestionEvent.reason === 'input-changed') {
      this.setState(prevState => {
        const legsArray = [...prevState.legs]
        legsArray[index][field] = undefined
        return { items: legsArray }
      })

      if (this.validateLength(suggestionEvent.value)) {
        const { countries, regions, cities } = getCampaignConstraints(
          group,
          this.props.campaignProps
        )

        this.props.fetchSuggestions(suggestionEvent.value, index, group, countries, regions, cities)
      }
    }
  }

  onAutoCompleteChange = (legNumber, value, fieldType) => {
    !value && this.props.fetchSearchBoxRules()
    if (!value) {
      this.setState(prevState => {
        const legsArray = [...prevState.legs]
        legsArray[legNumber][fieldType] = undefined
        return { items: legsArray }
      })
    }
  }

  handleSuggestionSelected = (suggestion, index, field, position) => {
    this.setState(
      prevState => {
        const legsArray = [...prevState.legs]
        legsArray[index][field] = suggestion
        return { items: legsArray }
      },
      () => {
        this.onFlightRouteChange()
        this.callbackToValidate(position, index)
      }
    )
  }

  getConfigPassengerContainer = () => (
    <ConfigPassengerInput
      restrictions={this.props.campaignProps && this.props.campaignProps.availablePassengers}
      isConference={this.props.campaignProps && this.props.campaignProps.isConference}
      campaignPropsAvailableCabins={
        this.props.campaignProps && this.props.campaignProps.availableCabins
      }
      cabins={this.props.cabins}
      availableCabins={this.props.availableCabins}
      isResearchBoxExpanded={this.props.isResearchBoxExpanded}
      isResearch={this.props.isResearch}
      handlePassengersDataChange={this.handlePassengersDataChange}
      conferenceCodeHandler={this.conferenceCodeHandler}
      passengers={this.state.passengers}
      conferenceCode={this.state.conferenceCode}
      isMultidestiny={this.state.flightTypes === TRIP_TYPES.MULTIDESTINY}
      passengersError={this.state.passengersError}
      noResults={this.props.noResults}
    />
  )

  handleScrollToOrigin = (isMultidestiny, index) => {
    /* Only scroll component to top when:
   - clicking in origin input or
   - in case of multiple trips, clicking in first origin input if
   not added additional trips */
    if (
      (isMultidestiny && index === 0 && this.state.legs.length <= 2) ||
      this.state.flightTypes !== TRIP_TYPES.MULTIDESTINY
    ) {
      this.scrollToComponent(this.container.current, {
        offset: isTablet(this.props.mediaType) && -30, // due to header
        align: isMobileOrTablet(this.props.mediaType) ? 'top' : 'middle',
        duration: 800,
        ease: 'inOutQuad'
      })
    }
  }

  render() {
    const ARRAY_LENGTH_OFFSET = 1
    const isMultidestiny = this.state.flightTypes === TRIP_TYPES.MULTIDESTINY
    const {
      suggestionsFrom,
      suggestionsTo,
      isResearch,
      isResearchBoxExpanded,
      isCampaignRestricted,
      campaignProps,
      isFetchingCampaigns
    } = this.props

    const countriesTo = !isEmpty(campaignProps) && campaignProps.availableCountryDestinations
    const regionsTo = !isEmpty(campaignProps) && campaignProps.availableRegionDestinations
    const countriesFrom = !isEmpty(campaignProps) && campaignProps.availableCountryOrigins
    const regionsFrom = !isEmpty(campaignProps) && campaignProps.availableRegionOrigins
    const flexDatesAllowed = !isEmpty(campaignProps) ? campaignProps.flexDatesAllowed : true
    const awardBookingAllowed = !isCampaignRestricted

    const isConference = !isEmpty(campaignProps) && campaignProps.isConference

    const iterableConditionalFields =
      this.state.conditionalFields && Object.entries(this.state.conditionalFields)
    const showDeleteLeg = isMultidestiny && this.state.legs.length > 2
    const mobileOrTablet = isMobileOrTablet(this.props.mediaType)
    const showMultidestiny = isMultidestiny && !(isResearch && !mobileOrTablet)

    const isArgentinaSite =
      this.props.i18n.language == 'es-AR' || this.props.i18n.language == 'en-AR'

    return (
      <React.Fragment>
        <ModalRedirectionPaymentGateway
          redirectionPaymentGateway={this.state.redirectionPaymentGateway}
        />
        {this.props.isAsyncValidating && <TransitionLoader />}
        {isCampaignRestricted && isFetchingCampaigns ? (
          <WaitingForResultLoader />
        ) : (
          <StyledContainer>
            <RadioGroupContainer>
              <RadioGroup
                name="flightTypes"
                options={getFlightTypesRadioGroupOptions(
                  this.props.campaignProps && this.props.campaignProps.flightTypes,
                  this.props.t,
                  this.state.flightTypes
                )}
                onChange={this.handleFlightTypeChange}
                horizontal
                paddingBottomOption={15}
              />
            </RadioGroupContainer>
            <ColumnsContainer>
              <Container
                ref={this.container}
                isConference={isConference}
                isResearch={isResearch}
                isResearchBoxExpanded={isResearchBoxExpanded}
              >
                {this.props.noResults && !mobileOrTablet && !this.state.clearErrorMessage && (
                  <ReSearchBoxErrorMessage flightType={this.state.flightTypes} />
                )}

                <FieldsContainer
                  flexDatesAllowed={flexDatesAllowed}
                  flexDirection={(isConference || isMultidestiny) && 'column'}
                >
                  {this.state.legs.map(
                    (
                      {
                        fromSelected,
                        toSelected,
                        fromError,
                        toError,
                        dateFromError,
                        dateToError,
                        isExpanded,
                        date
                      },
                      index
                    ) =>
                      (index === 0 || (index > 0 && isMultidestiny)) && (
                        <Fragment key={index}>
                          <Leg
                            key={index}
                            legIndex={index}
                            showMultidestiny={showMultidestiny}
                            flexDirection={isConference && 'column'}
                          >
                            {showMultidestiny && (
                              <MultidestinyHeader
                                handleClick={() => mobileOrTablet && this.collapseLeg(index)}
                                title={this.props.t('shopping.search-box.multidestiny.leg-title', {
                                  leg: getOrdinal(index + 1)
                                })}
                                isExpanded={isExpanded}
                                mobileOrTablet={mobileOrTablet}
                              />
                            )}
                            <InputWrapper
                              isExpanded={this.shouldShowLegContent(index)}
                              isConference={isConference}
                            >
                              <div onClick={() => this.handleScrollToOrigin(isMultidestiny, index)}>
                                <AirportInput
                                  index={index}
                                  isConference={isConference}
                                  isResearch={isResearch}
                                  selected={fromSelected}
                                  error={fromError}
                                  isExpanded={isResearchBoxExpanded}
                                  name="origin"
                                  e2eClass="searchBox.origin"
                                  fieldLabel={this.props.t('shopping.search-box.origin')}
                                  isCampaignRestricted={isCampaignRestricted}
                                  suggestions={suggestionsFrom}
                                  exclusionValue={toSelected}
                                  swapOriginDestination={this.swapOriginDestination}
                                  handleInputChange={this.handleInputChange}
                                  onAutoCompleteChange={this.onAutoCompleteChange}
                                  onFetchSuggestions={suggestion =>
                                    this.props.fetchSuggestions(
                                      suggestion?.id,
                                      index,
                                      SEARCH_BOX.SUGGESTIONS_GROUP_FROM_KEY,
                                      countriesFrom,
                                      regionsFrom
                                    )
                                  }
                                  handleSuggestionSelected={this.handleSuggestionSelected}
                                  fieldType="fromSelected"
                                  suggestionType={SEARCH_BOX.SUGGESTIONS_GROUP_FROM_KEY}
                                  fieldPosition={SEARCH_BOX.FROM_POSITION}
                                  swapButtonOnMobile
                                />
                              </div>
                              {!isEmpty(campaignProps) ? (
                                <Separator />
                              ) : (
                                <SwapFieldsWrapper>
                                  <SwapFieldsButton
                                    onClick={() => this.swapOriginDestination(index)}
                                  />
                                </SwapFieldsWrapper>
                              )}
                              <AirportInput
                                index={index}
                                isConference={isConference}
                                isResearch={isResearch}
                                selected={toSelected}
                                error={toError}
                                isExpanded={isResearchBoxExpanded}
                                name="destination"
                                e2eClass="searchBox.destiny"
                                fieldLabel={this.props.t('shopping.search-box.destination')}
                                isCampaignRestricted={isCampaignRestricted}
                                suggestions={suggestionsTo}
                                exclusionValue={fromSelected}
                                swapOriginDestination={this.swapOriginDestination}
                                handleInputChange={this.handleInputChange}
                                onAutoCompleteChange={this.onAutoCompleteChange}
                                onFetchSuggestions={suggestion =>
                                  this.props.fetchSuggestions(
                                    suggestion?.id,
                                    index,
                                    SEARCH_BOX.SUGGESTIONS_GROUP_TO_KEY,
                                    countriesTo,
                                    regionsTo
                                  )
                                }
                                handleSuggestionSelected={this.handleSuggestionSelected}
                                fieldType="toSelected"
                                suggestionType={SEARCH_BOX.SUGGESTIONS_GROUP_TO_KEY}
                                fieldPosition={SEARCH_BOX.TO_POSITION}
                              />
                              <Separator />
                              <DatePickerWrapper
                                isConference={isConference}
                                isResearch={isResearch}
                                isMulti={this.state.flightTypes === TRIP_TYPES.MULTIDESTINY}
                                isRoundTrip={this.state.flightTypes === TRIP_TYPES.ROUND_TRIP}
                                legIndex={index}
                                legs={this.state.legs}
                                dateFromError={dateFromError}
                                dateToError={dateToError}
                                isResearchBoxExpanded={isResearchBoxExpanded}
                                date={date}
                                handleDateChange={value =>
                                  this.handleDateFromInputChange(value, index)
                                }
                                placeholder={this.props.t('general.date-picker.date-format')}
                              />
                              {showDeleteLeg && !mobileOrTablet && (
                                <EditLegLink
                                  index={index}
                                  label={this.props.t('shopping.search-box.remove-leg-link')}
                                  onEditLeg={() => this.removeLeg(index)}
                                  iconName={IconNames.Close}
                                  name="delete-leg"
                                />
                              )}
                              {showDeleteLeg && mobileOrTablet && (
                                <EditLegLink
                                  index={index}
                                  label={this.props.t('shopping.search-box.remove-leg-link')}
                                  onEditLeg={() => this.removeLeg(index)}
                                  iconName={IconNames.Close}
                                  name="delete-leg"
                                />
                              )}
                            </InputWrapper>
                          </Leg>
                          {isMultidestiny &&
                            this.state.legs.length < SEARCH_BOX.MAX_LEGS_FLIGHTS &&
                            this.state.legs.length === index + 1 && (
                              <EditLegLink
                                label={this.props.t('shopping.search-box.add-leg-link')}
                                onEditLeg={() => this.addLeg()}
                                iconName={IconNames.Plus}
                                isResearch={isResearch}
                                name="add-leg"
                              />
                            )}
                          {showMultidestiny && (
                            <SeparatorWrapper last={this.state.legs.length === index + 1}>
                              <DashedSeparator nomargin color={theme.colors.alto} />
                            </SeparatorWrapper>
                          )}
                        </Fragment>
                      )
                  )}
                  <Separator />
                  {/* config passenger for desktop home*/}
                  {!isResearch && !mobileOrTablet && this.getConfigPassengerContainer()}
                </FieldsContainer>
                {/* config passenger for mobile home*/}
                {mobileOrTablet && this.getConfigPassengerContainer()}
                {!isEmpty(iterableConditionalFields) && !isResearch && (
                  <CampaignConditionalFields>
                    {iterableConditionalFields.map(
                      ([fieldCode, { placeholder, value, error }], index) => (
                        <CampaignConditionalFieldsItem
                          key={`${placeholder}--${fieldCode}`}
                          isLast={index === iterableConditionalFields.length - ARRAY_LENGTH_OFFSET}
                        >
                          {!mobileOrTablet && (
                            <CampaignInputLabel>{placeholder}</CampaignInputLabel>
                          )}
                          <Input
                            label={mobileOrTablet ? placeholder : undefined}
                            placeholder={placeholder}
                            boxShadow
                            onChange={this.handleCampaignFieldsChange(fieldCode)}
                            value={value}
                            error={error}
                          />
                        </CampaignConditionalFieldsItem>
                      )
                    )}
                  </CampaignConditionalFields>
                )}
              </Container>
              {isResearch && (
                <StyledBtnContainer
                  isMultidestiny={isMultidestiny}
                  noResults={this.props.noResults}
                >
                  <FragmentContainer justifyContent={!isMultidestiny && 'flex-end'}>
                    <Fragment>
                      <Separator />
                      {/* config passenger for research desktop*/}
                      {!mobileOrTablet && this.getConfigPassengerContainer()}
                      <Separator />
                      {!mobileOrTablet && this.getSearchButton()}
                    </Fragment>
                  </FragmentContainer>
                </StyledBtnContainer>
              )}
            </ColumnsContainer>

            <div>
              <StyledContainer>
                <SwitchersContainer>
                  {CONFIG.ENABLE_MILES &&
                    awardBookingAllowed &&
                    isArgentinaSite &&
                    (this.state.flightTypes === TRIP_TYPES.ONE_WAY ||
                      this.state.flightTypes === TRIP_TYPES.ROUND_TRIP) && (
                      <SwitcherContainer>
                        <Switcher
                          name="award-booking"
                          e2eClass={e2eClasses('searchBoxFlights.awardBooking')}
                          textRight={this.props.t('shopping.search-box.award-booking')}
                          onChange={this.handleAwardBookingChange}
                          checked={this.state.awardBooking}
                          notCenter
                        />
                      </SwitcherContainer>
                    )}
                  {flexDatesAllowed &&
                    (this.state.flightTypes === TRIP_TYPES.ONE_WAY ||
                      this.state.flightTypes === TRIP_TYPES.ROUND_TRIP) && (
                      <SwitcherContainer>
                        <Switcher
                          name="flex-dates"
                          e2eClass={e2eClasses('searchBoxFlights.flexDates')}
                          textRight={this.props.t('shopping.search-box.have-flex-dates')}
                          onChange={this.handleFlexDatesChange}
                          checked={this.state.flexDates}
                          notCenter
                        />
                      </SwitcherContainer>
                    )}
                </SwitchersContainer>
                <SwitchersContainer>
                  {CONFIG.ENABLE_PROMO_CODE &&
                    this.state.promoCodeEnabled &&
                    !this.state.awardBooking && (
                      <PromotionCode
                        handlePromoCodeCheckChange={this.handlePromoCodeCheckChange}
                        handlePromoCodeChange={this.handlePromoCodeChange}
                        errorPromoCode={this.state.errorPromoCode}
                        promoCode={this.state.promoCode}
                      />
                    )}
                </SwitchersContainer>
              </StyledContainer>
            </div>

            <FragmentContainer justifyContent={'center'} width={'100%'}>
              {!(isResearch && !mobileOrTablet) && this.getSearchButton()}
            </FragmentContainer>
          </StyledContainer>
        )}
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  fetchCabins,
  resetAllModals,
  swipeSuggestions,
  fetchSuggestions,
  fetchSearchBoxRules,
  clearFlightSummary,
  fetchFlightsOffers,
  clearAllSuggestions,
  changeModalState
}

const mapStateToProps = state => ({
  cabins: getCabins(state),
  suggestionsFrom: getSuggestionsFrom(state),
  suggestionsTo: getSuggestionsTo(state),
  availableCabins: getAvailableCabins(state),
  mediaType: mapMediaType(state),
  isFetchingCampaigns: isFetchingCampaigns(state),
  campaignError: getCampaignFetchError(state),
  conferenceCodeError: getConferenceCodeError(state),
  isAsyncValidating: getFlightsOffersIsFetching(state),
  promoCodeEnabledByRule: getPromoCodeEnabled(state),
  defaultFlightType: getDefaultFlightType(state)
})

SearchBox.propTypes = {
  flexDates: PropTypes.bool,
  passengers: PropTypes.object,
  flightTypes: PropTypes.oneOf(Object.values(TRIP_TYPES)),
  leg: PropTypes.object,
  availableCabins: PropTypes.array,
  isCampaignRestricted: PropTypes.bool, // needed to fetch on didMount the right config (rules or campaign)
  campaignProps: PropTypes.object,
  campaignFieldsInitialValues: PropTypes.object,
  shouldShowTermsLink: PropTypes.bool
}

export default withTranslation(NAMESPACES.SEARCH_BOX)(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(withRouter(SearchBox))
)
